import cx from "classnames";
import { type FC } from "react";

import { LEVEL_VARIANT_CLASSES } from "../../../Chip/constants";
import { type ColorVariant } from "../../../Chip/types";

export const TagColor: FC<{ color: ColorVariant }> = ({ color }) => {
	return (
		<div className="flex">
			<div
				className={cx(
					"tag-color-selection-container",
					"outline-2",
					"flex",
					"items-center",
					"justify-center",
					"rounded-full",
					"h-6",
					"w-6",
					"font-medium",
					LEVEL_VARIANT_CLASSES["secondary"][color]["background"],
					LEVEL_VARIANT_CLASSES["secondary"][color]["text"]
				)}
			>
				{/* TODO: label etc */}
				<div>A</div>
			</div>
		</div>
	);
};
